import _ from 'lodash';
import { connect } from 'react-redux';
import { fetchBlogItems } from 'client/actions/blog';
import { smsKey } from 'routes/tax/components/constants';

import TaxLandingPage from './taxLandingPage';

const brand = 'hrblock';
const heroLogoSrc =
  'https://images.contentful.com/heg7gyzix6dq/4BSoB6C9SgIYcqcEgY4S62/e548d4168200ff307e35e051eae3ee35/stride___hrb.svg';
const source = 'HRB Tax LP';

const mapStateToProps: Object = state => ({
  blogPosts: _.get(state, 'blog.sections.taxes', []).slice(0, 3),
  brand,
  contentfulData: state.contentfulData || {},
  heroLogoSrc,
  smsKey,
  smsSuccess: _.find(state.sms.received, { key: smsKey }),
  source,
});

export default connect(mapStateToProps, {
  fetchBlogItems,
})(TaxLandingPage);
